<template>
    <div style="display: flex; flex-direction: column;">
        <div v-for="(file, index) in fileList" :key="index" style="padding: 5px;">
            <el-link :underline="false" type="primary" @click="handleFilePreview(file)">{{file.name||file.filename}}</el-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "FileListRender",
    props: {
        fileList: {
            type: Array,
            default: []
        },
    },
    data()
    {
        return {}
    },
    methods:
    {
        handleFilePreview(file)
        {
            window.open(file.url);
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/erp/components/render/FileListRender.vue